export const defaultTexts = {
  toolbarButtons: {
    boldButtonLabel: 'Bold',
    italicButtonLabel: 'Italic',
    underlineButtonLabel: 'Underline',
    linkButtonLabel: 'Insert link',
    bulletedListButtonLabel: 'Bulleted List',
    numberedListButtonLabel: 'Numbered List',
  },
  insertionForm: {
    confirmButtonLabel: 'Confirm',
    cancelButtonLabel: 'Cancel',
    link: {
      textInputPlaceholder: 'Text to display',
      urlInputPlaceholder: 'URL this link should go',
    },
  },
};
